module.exports = __webpack_public_path__ + "img/12.f788bfa1.png";